import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from '../../services/shared/pager.service';
import { AppService } from '../../services/app/app.service';
import { Notification } from '../../models/notification/notification.model';
import { TrigerNotification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';
import { parse } from 'querystring';
import { CookieService } from 'ngx-cookie-service';
import { ProfileService } from '../../services/profile/profile.service';
import { User } from '../../models/user/user-model';
import { PushNotificationService } from '../../services/notification/push-notification.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  public pushnotificationList: TrigerNotification[];
  public notificationList: TrigerNotification[];
  public popupNotificationList: TrigerNotification[];
  public notificationCounter: number;
  public customerTypeId: number = 3; // 3 is for vistor
  public showToggle: boolean = false;
  public roleId: number;
  public userId: number;
  public user: User = new User();
  imagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";

  constructor(private readonly notificationService: NotificationService,
    private readonly appService: AppService,
    private readonly profileService: ProfileService,
    private cookieService: CookieService,
    private readonly router: Router, private _notificationService: PushNotificationService,
    public toastr: ToastsManager, vcr: ViewContainerRef, ) {
    this.pushnotificationList = [];
    this.popupNotificationList = [];
    this.notificationCounter = 0;
    this.GetProfile();
    this.notificationCounter = 0;
    this.notificationList = [];
    //this.GetNotificationCount();
  }
  GetProfile() {
    this.profileService.getProfile().subscribe(
      data => {
        if (data != null) {
          this.user = data;
          this.userId = this.user.userID;
          this.roleId = Number(this.user.roleID);
          if (this.user && this.user.imagePath != "" && this.user.imagePath != null) {
            this.imagePath = this.user.imagePath;
          }
          else {
            this.imagePath = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
          }
        }
        this.GetHeaderNotificationList();
        this.notify();
      });
  }
  notify() {
    this.notificationService.GetPushNotification(this.roleId,this.userId).subscribe(
      data => {
        
        this.pushnotificationList = data;
        let notifications: Array<any> = [];
        for (var i = 0; i < this.pushnotificationList.length; i++) {
          if (!this.cookieService.check(this.pushnotificationList[i].notificationID.toString())) {
            this.cookieService.set(this.pushnotificationList[i].notificationID.toString(), this.pushnotificationList[i].title);
            notifications.push({
              'title': this.pushnotificationList[i].title == null ? "Notification" : this.pushnotificationList[i].title,
              'alertContent': this.pushnotificationList[i].notificationDetail
            });
          }

        }
        this._notificationService.generateNotification(notifications);
      }
    )
  }
  PopupNotification() {
    this.notificationService.GetPopupNotification(this.roleId, this.userId).subscribe(
      data => {
        if (data) {
          this.popupNotificationList = data;
          for (var i = 0; i < this.popupNotificationList.length; i++) {

            this.toastr.info(this.popupNotificationList[i].notificationDetail, 'Information');
          }
        }
          

      }
    )
  }
  GetNotificationCount() {
    this.notificationService.GetNotificationCount(this.userId, this.roleId).subscribe(
      data => {
        this.notificationCounter = data;
      }
    )
  }
  CheckNotification() {
    this.notificationService.CheckNotification(this.userId, this.roleId).subscribe(
      data => {
        if (data == true) {
          this.GetNotificationCount();
        }
      }
    )
  }

  MinifiedMenu() {
    //  myFunction() {
        this.showToggle = !this.showToggle;
    //}

    //var id  = "mainAdminBody";
    //var element = document.getElementById(id) as HTMLElement;
    
  }

  GetHeaderNotificationList() {
    this.notificationService.GetHeaderNotification(this.roleId, this.userId).subscribe(
      data => {
        this.notificationList = data;
        this.GetNotificationCount();
        //this.PopupNotification();
      }
    )
  }

  Logout() {
    this.appService.Logout(this.cookieService.get('Login')).subscribe(
      data => {
        if (data) {
          this.cookieService.delete('Login')
          this.router.navigate(["login"]);
        }
      });
  }
  //isExpanded = false;

  //collapse() {
  //  this.isExpanded = false;
  //}

  //toggle() {
  //  this.isExpanded = !this.isExpanded;
  //}
}



// WEBPACK FOOTER //
// ./src/app/ui-components/nav-menu/nav-menu.component.ts